import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

import packageJSON from '../../../package.json';
import { IS_RUNNING_TESTS } from '../../common/constants';

/**
 * Configures the Sentry setup for this repo.
 */
export function setupSentry() {
  Sentry.init({
    release: `se-home(${packageJSON.version})@` + import.meta.env.VITE_SENTRY_RELEASE,
    dsn: import.meta.env?.VITE_SENTRY_DSN as string,
    // Allows event caching while offline (e.g. Wi-Fi commissioning with no mobile Internet)
    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
    beforeSend(event) {
      if (IS_RUNNING_TESTS) return null;

      // TODO for now we comment out this part as we test other settings.
      /*
      if (!event.extra) event.extra = {};
      event.extra['AppVersion'] = packageJSON.version;

      if (event.exception) {
        const errorMessage = event.exception.values?.[0]?.value;

        if (errorMessage) {
          // Group "Request failed with status code 400" errors
          if (errorMessage.includes('Request failed with status code 400')) {
            event.fingerprint = ['axios-400-error'];
          }
          // Group "No session available" errors
          else if (errorMessage.includes('No session available')) {
            event.fingerprint = ['no-session-available-error'];
          }
          // Group "Request aborted" errors
          else if (errorMessage.includes('Request aborted')) {
            event.fingerprint = ['request-aborted-error'];
          }
        }
      }
      */

      return event;
    },
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    environment: import.meta.env?.['MODE'],
    tracesSampleRate: 0.05,

    // This helps refine sentry error reporting by ignoring known errors that don't need fixing
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
    ],
  });
}
